import * as React from 'react';
import { prefixCls } from '../../utils';
import './NonEditable.less';
import { jsx as _jsx } from "react/jsx-runtime";

function transVal(props) {
  var _options$find;

  const valueIn = props.value;
  const options = props.options;

  if (options == null) {
    if (typeof valueIn === 'string' || typeof valueIn === 'number') {
      return valueIn.toString();
    }
  }

  return options === null || options === void 0 ? void 0 : (_options$find = options.find(v => {
    return v.value === valueIn;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label;
}

export const NonEditable = props => {
  const value = transVal(props);
  return /*#__PURE__*/_jsx("span", {
    className: `${prefixCls}-text`,
    children: value
  });
};
//# sourceMappingURL=es/Other/Field/NonEditable.js.map